import React from 'react';
import { Box } from '@mui/material';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import ChevronLeft from '!svg-react-loader!src/components/BeaconV2Components/Pagination/assets/chevronLeft.svg';
import ChevronRight from '!svg-react-loader!src/components/BeaconV2Components/Pagination/assets/chevronRight.svg';

interface LibraryPaginationProps {
  pageNumber: number;
  setPageNumber: (page: number) => void;
  hasNextPage?: boolean;
}

const iconStyle: React.CSSProperties = {
  position: 'relative',
  top: '2px',
  cursor: 'pointer',
  width: '24px',
  height: '24px'
};

export const LibraryPagination: React.FC<LibraryPaginationProps> = ({
  pageNumber,
  setPageNumber,
  hasNextPage = false
}) => {
  const disablePrevious = pageNumber <= 1;
  const disableNext = !hasNextPage;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', marginTop: '24px' }}>
      <ChevronLeft
        style={{
          ...iconStyle,
          opacity: disablePrevious ? 0.4 : 1,
          pointerEvents: disablePrevious ? 'none' : 'auto'
        }}
        onClick={() => setPageNumber(pageNumber - 1)}
        role="button"
      />
      <Text
        variant="body2"
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          lineHeight: '18px',
          color: colors.darkBlue
        }}
      >
        Page {pageNumber}
      </Text>
      <ChevronRight
        style={{
          ...iconStyle,
          opacity: disableNext ? 0.4 : 1,
          pointerEvents: disableNext ? 'none' : 'auto'
        }}
        onClick={() => setPageNumber(pageNumber + 1)}
        role="button"
      />
    </Box>
  );
};
